import { Box } from "@material-ui/core";
import React from "react";
import {
  TTHTNumber,
  TTHTSectionSubTitle,
  TTHTSectionText,
} from "../TeachersToolkitHowTo/TeachersToolkitHowTo.styled";

export const TTHTBullet = ({ number, title, text }) => {
  return (
    <Box display="flex">
      <Box marginRight="0.75rem">
        <TTHTNumber>{number}</TTHTNumber>
      </Box>
      <Box display="flex" flexDirection="column">
        <TTHTSectionSubTitle>{title}</TTHTSectionSubTitle>
        <TTHTSectionText>{text}</TTHTSectionText>
      </Box>
    </Box>
  );
};



// WEBPACK FOOTER //
// ./resources/assets/js/app/TeachersToolkit/components/TTHTBullet.js